export abstract class BaseModel {
}
